
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Founders', href: '/founders' },
    { name: 'Investment Thesis', href: '/investment-thesis' },
    { name: 'Pitch Us', href: '/pitch' },
    { name: 'Accelerator Playbook', href: '/accelerator-playbook' },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
    // Scroll to top when navigating
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={handleNavClick}>
            <div className="text-2xl font-bold text-white" style={{ fontFamily: '"Playfair Display", serif' }}>
              EULA VC
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link 
                key={item.name}
                to={item.href} 
                className={`px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.href
                    ? 'text-white border-b-2 border-white'
                    : 'text-white hover:text-teal-400'
                }`}
                onClick={handleNavClick}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-white hover:text-teal-400 transition-colors p-2"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-800">
            <nav className="flex flex-col space-y-1">
              {navigation.map((item) => (
                <Link 
                  key={item.name}
                  to={item.href} 
                  className={`block px-3 py-2 text-base font-medium transition-colors cursor-pointer ${
                    location.pathname === item.href
                      ? 'text-white bg-slate-800'
                      : 'text-white hover:text-teal-400 hover:bg-slate-800'
                  }`}
                  onClick={handleNavClick}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
